export const APP_STORE_KEY = 'app';
